import React, { useEffect, useState } from "react";
import "./Device_Warning.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faDesktop } from "@fortawesome/free-solid-svg-icons";

const Device_Warning = () => {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  if (!isMobile) {
    return null;
  }

  return (
    <div className="device-warning">
      <div className="device-warning-card">
        <div className="device-warning-icon">
          <img src="/assets/images/warning.jpg" alt="warning" />

          {/* <FontAwesomeIcon icon={faDesktop} /> */}
        </div>

        {/* <h2>Desktop View Required</h2> */}

        <p>
          This application is currently optimized for desktop and tablet
          screens.
        </p>
      </div>
    </div>
  );
};

export default Device_Warning;
